import { ALL_ANIMAL_PICS } from "./data";
import { ALL_ANIMAL_INFO } from "./data";
import { explosionTextures } from "../data";

const validOperations = [
    "add","subtract","multiply","divide"
  ]

export const hasDecimal = (aString) => {
    return aString.includes(".")
  }
  
export const performOperation = (operation,operand1,operand2) => {
    switch(operation){
      case "add":
        console.log(`Adding ${operand1} and ${operand2}`)
        return operand1 + operand2;
      case "multiply":
        console.log(`Multiplying ${operand1} and ${operand2}`)
        return operand1*operand2;
      case "divide":
        console.log(`Dividing ${operand1} by ${operand2}`)
        return operand1/operand2;
      case "subtract":
        console.log(`Subtracting ${operand2} from ${operand1}`)
        return operand1 - operand2;
      default:
        break;
    
    }
  }

  
  
  export const getRandomOperation = () => {
    return validOperations[Math.floor(Math.random()*validOperations.length)];
  }
  
  export const getRandomInteger = (fromMin,toMax) => {
    return Math.floor(Math.random()*(toMax-fromMin)) - fromMin;
  }
  
  export const getCorrectAnswer = (operand1, operand2, operation) => {
  
    switch(operation){
       case "add":
          return operand1 + operand2; 
       case  "multiply":
          return operand1*operand2;
        case "subtract":
          return operand1 - operand2;
        case "divide":
          return parseFloat((operand1/operand2).toFixed(2));
        default:
          break;
    }
  }


function getRandomAnimalPic(){
    let randomIdx = Math.floor(Math.random()*ALL_ANIMAL_PICS.length);
    return ALL_ANIMAL_PICS[randomIdx];
}

function getRandomAnimalInfo(){
    let randomIdx = Math.floor(Math.random()*ALL_ANIMAL_INFO.length);
    return ALL_ANIMAL_INFO[randomIdx];
}

export default {getRandomAnimalPic,getRandomAnimalInfo};




export function runAnimation(imgElement,baseImgPath,textures, finishCallback){
   
    let textureIndex = 0;

    let animationIntervalID = setInterval(() => {
      
        imgElement.src = textures[textureIndex];
        console.log(imgElement);
        
        if(textureIndex === textures.length){
            imgElement.src = baseImgPath;
            clearInterval(animationIntervalID);
            finishCallback();
          
        } else {
            textureIndex++;
        }
    },100);
}

export function runExplosionAnimation(imgElement,basePathImg,finishCallback){
    runAnimation(imgElement,basePathImg,explosionTextures,finishCallback);
}

export function checkForCollision(rect1,rect2,collisionCallback,noCollisionCallback){
    if (rect1.x + rect1.width/2 > rect2.x 
        && rect1.x + rect1.width/2 < rect2.x + rect2.width 
        && rect1.y + rect1.height/2 > rect2.y 
        && rect1.y + rect1.height/2 < rect2.y + rect2.height) {
        
            
            collisionCallback();
       
 } else {
    noCollisionCallback();
  
 }
}